/**
 * Flag de PostHog para lo nuevo de Cashea que ven comercios que no lo pidieron:
 * la elección con Cashea Link ("¡Nuevo!") para los que tienen solo el QR y el
 * formulario de solicitud de conexión en el onboarding.
 *
 * Booleano y fail-closed (`getExperimentVariant` → false si no existe o no
 * cargó): apagado, el cobro con QR va directo al QR y el onboarding ofrece el
 * chat de Intercom, como antes. Link en sí no depende del flag: un comercio lo
 * ve solo si soporte se lo habilita (`cashea.methods.link`).
 */
export const CASHEA_LINK_FLAG = 'cashea-link';

/**
 * Flag de PostHog para pausar Cashea Link a todos los comercios sin desplegar.
 *
 * Encendido, no se pueden generar links nuevos ni se ofrece activarlo; las
 * órdenes ya creadas siguen en su pestaña para poder cerrarlas. Es fail-open:
 * si PostHog no cargó, Link funciona como siempre.
 */
export const CASHEA_LINK_PAUSED_FLAG = 'cashea-link-paused';

export const CASHEA_LINK_PAUSED_MESSAGE = 'Pausamos Cashea Link temporalmente mientras se resuelve un problema con Cashea.';
